import { Inject, Options, Provide, Prop, Vue, Watch, Emit } from "vue-property-decorator";
// import SignatoryCard from "./signatory-card/index.vue";
import { TrustAPI } from "@/shared/modules/trust-api";
import store from "@/trust-atcs-app/store";
import { EventEmitter } from "events";
import { AppInsights } from "@/trust-atcs-app/appInsights";
import { ComplianceForm, SolelyJointly } from "@/shared/modules/typescript-trustapi-client/models";
import ViewSignatoryModal from "./view-signatory-modal/index.vue";
import { RouteN } from "@/trust-atcs-app/constants/router-name";
import ContinueToManageSignatories from "../../continue-to-manage-signatories/index.vue";

@Options({
  components: {
    // SignatoryCard,
    ViewSignatoryModal,
    ContinueToManageSignatories
  }
})
export default class Signatories extends Vue {
  @Inject({ from: 'apiService', default: new TrustAPI() })
  private apiService!: TrustAPI;

  private ai = new AppInsights;

  get eventCtrl(): EventEmitter {
    return store.getters.getEventController;
  }

  @Prop()
  private signatories!: any[];

  @Prop()
  private isConfirmed!: boolean | null;

  @Prop()
  private qWording!: string;

  @Emit('validForm')

  @Emit('update:isConfirmed')
  emitConfirmed(value: boolean | null) {
    this.$emit('validForm', this.validForm());
    return value;
  }


  private uniqueIdName = null as any;
  private localConfirmed: boolean | null = null;
  private showSignatoryModal = false;
  private continueToManageSignatoriesModalOpened = false;

  private generateUUID() {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
      const r = Math.random() * 16 | 0,
        v = c === 'x' ? r : (r & 0x3 | 0x8);
      return v.toString(16);
    });
  }

  created(): void {
    // this.loadList();
    this.localConfirmed = this.isConfirmed;
    this.uniqueIdName = 'RadioHorizontal-' + this.generateUUID();
  }

  mounted(): void {
    this.$emit('validForm', this.validForm());
  }

  // private async loadList(): Promise<void> {
  //   try {
  //     const resp1: any = await this.apiService.CodeApi?.apiV2CodeGetCategoriesGet();
  //     const resp2: any = await this.apiService.CodeApi?.apiV2CodeGetSolelyJointliesGet();
  //     this.categoriesTypeSig = resp1.data.data;
  //     this.solelyJointlyTypeSig = resp2.data.data;
  //   } catch (err) {
  //     this.eventCtrl.emit('show-snackbar', 'error', 'Error loading options list');
  //     this.ai.trackException('Error loading options list: ' + err);
  //     // this.errorLoadingContent = true;
  //     console.log(err);
  //   } finally {
  //     // this.loadingContent = false;
  //   }

  // }

  // private async addSignatory() {
  //   const newSignatory: any = (
  //     {
  //       isNewlyAdded: true,
  //       id: 0,
  //       complianceFormId: this.complianceFormB.id,
  //       firstName: null,
  //       lastName: null,
  //       commencedDate: new Date(),
  //       terminatedDate: null,
  //       categoryId: null,
  //       solelyJointlyId: null,
  //       updatingKey: this.updatingKey,
  //     });
  //   this.signatories.push(newSignatory);
  //   // save the current section and reloading data
  //   this.eventCtrl.emit('save-section', false, true, false);
  // }

  private validForm(): boolean {
    return this.signatories.length > 0 && this.validFormSignatory();
  }

  // private removeSignatory(index: number) {
  //   this.signatories.splice(index, 1);
  //   this.eventCtrl.emit('save-section', false, true, false);
  //   this.$emit('validForm', this.validForm());
  // }

  private goToManageAuthorisedSignatories(): void {
    this.eventCtrl.emit('save-and-custom-action', () => {
      this.$router.push({ name: RouteN.ATCS.ManageAuthorisedSignatories.n, query: { practiceCoreId: this.complianceFormB.practice?.practiceCoreId } });
    });
  }

  private validFormSignatory(): boolean {
    return this.isConfirmed === true;
  }

  private answered(): boolean {
    return this.isConfirmed != null;
  }

  get complianceFormB(): ComplianceForm {
    return store.getters.getSelectedComplianceFormB;
  }

  get updatingKey(): string {
    return store.getters.getFormUpdatingKey;
  }

}



